module.exports = __webpack_public_path__ + "img/icon-vk.9eaa3aa7.svg";